export enum ApiStatus {
  NONE,
  LOADING,
  SUCCESS,
  ERROR,
}

export enum ApiErrorMessage {
  DEFAULT = 'Error occurred while fetching data.',
  INVALID_RESPONSE = 'Invalid API response.',
  NO_RECORDS = 'No records found.',
}

export enum ApiStateRequestType {
  IN_PROGRESS = 'inProgress',
  COMPLETED = 'completed',
}

export interface ApiStateGlobal {
  [key: string]: Record<ApiStateRequestType, boolean>;
}
